import api from 'plugin/api';

/**
 *  보고서 - 한계기준 이탈현황
 */

/**
 *  @description 한계기준 이탈현황 API
 */
async function limitExcd(params) {
  const url = '/sfsh/report/limitExcd';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 한계기준 이탈현황 상세내역 API
 */
async function limitExcdDetail(params) {
  const url = '/sfsh/report/limitExcd/detail';

  const response = await api.get(url, { params });
  return response;
}

export { limitExcd, limitExcdDetail };
